module.exports = __webpack_public_path__ + "img/img1.9136277c.jpg";